/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import '../common/currency';
import '../timecards/scheduling/models';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "employeejobs": {
        "nested": {
          "Wage": {
            "fields": {
              "wageType": {
                "type": "squareup.employeejobs.Wage.WageType",
                "id": 1,
                "rule": "optional"
              },
              "hourlyWage": {
                "type": "squareup.common.Money",
                "id": 2,
                "rule": "optional"
              },
              "annualWage": {
                "type": "squareup.common.Money",
                "id": 3,
                "rule": "optional"
              },
              "hoursWorkedPerWeek": {
                "type": "uint32",
                "id": 4,
                "rule": "optional"
              },
              "tipEligible": {
                "type": "bool",
                "id": 5,
                "rule": "optional"
              },
              "overtimeExempt": {
                "type": "bool",
                "id": 6,
                "rule": "optional"
              }
            },
            "nested": {
              "WageType": {
                "values": {
                  "HOURLY": 0,
                  "ANNUAL": 1,
                  "NONE": 2
                }
              }
            }
          },
          "Job": {
            "fields": {
              "token": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "merchantToken": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "title": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              },
              "defaultWage": {
                "type": "squareup.employeejobs.Wage",
                "id": 4,
                "rule": "optional"
              },
              "createdAtTimestampMs": {
                "type": "uint64",
                "id": 5,
                "rule": "optional"
              },
              "updatedAtTimestampMs": {
                "type": "uint64",
                "id": 6,
                "rule": "optional"
              },
              "deletedAtTimestampMs": {
                "type": "uint64",
                "id": 7,
                "rule": "optional"
              },
              "tipEligible": {
                "type": "bool",
                "id": 8,
                "rule": "optional",
                "options": {
                  "default": true
                }
              },
              "defaultColorScheme": {
                "type": "squareup.timecards.scheduling.ColorScheme",
                "id": 9,
                "rule": "optional",
                "options": {
                  "default": "LIGHT_BLUE"
                }
              },
              "teamMemberCount": {
                "type": "uint64",
                "id": 10,
                "rule": "optional"
              },
              "version": {
                "type": "uint64",
                "id": 11,
                "rule": "optional"
              }
            }
          },
          "JobAssignment": {
            "fields": {
              "token": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "merchantToken": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "employeeToken": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              },
              "job": {
                "type": "squareup.employeejobs.Job",
                "id": 4,
                "rule": "optional"
              },
              "wage": {
                "type": "squareup.employeejobs.Wage",
                "id": 5,
                "rule": "optional"
              },
              "createdAtTimestampMs": {
                "type": "uint64",
                "id": 6,
                "rule": "optional"
              },
              "updatedAtTimestampMs": {
                "type": "uint64",
                "id": 7,
                "rule": "optional"
              },
              "deletedAtTimestampMs": {
                "type": "uint64",
                "id": 8,
                "rule": "optional"
              },
              "colorScheme": {
                "type": "squareup.timecards.scheduling.ColorScheme",
                "id": 9,
                "rule": "optional",
                "options": {
                  "default": "LIGHT_BLUE"
                }
              }
            }
          },
          "WageData": {
            "fields": {
              "employeeToken": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "orderedJobAssignments": {
                "type": "squareup.employeejobs.JobAssignment",
                "id": 2,
                "rule": "repeated"
              },
              "overtimeExempt": {
                "type": "bool",
                "id": 3,
                "rule": "optional"
              },
              "createdAt": {
                "type": "string",
                "id": 4,
                "rule": "optional"
              },
              "updatedAt": {
                "type": "string",
                "id": 5,
                "rule": "optional"
              },
              "version": {
                "type": "uint64",
                "id": 6,
                "rule": "optional"
              },
              "itemCommissionBasisPoints": {
                "type": "uint64",
                "id": 7,
                "rule": "optional"
              },
              "serviceCommissionBasisPoints": {
                "type": "uint64",
                "id": 8,
                "rule": "optional"
              }
            }
          },
          "JobUpdate": {
            "fields": {
              "id": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "jobId": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "previousIsTipEligible": {
                "type": "bool",
                "id": 3,
                "rule": "optional"
              },
              "previousTitle": {
                "type": "string",
                "id": 4,
                "rule": "optional"
              },
              "newIsTipEligible": {
                "type": "bool",
                "id": 5,
                "rule": "optional"
              },
              "newTitle": {
                "type": "string",
                "id": 6,
                "rule": "optional"
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.employeejobs?.nested?.Wage && !$root.nested?.squareup?.nested?.employeejobs?.nested?.Wage?.nested?.WageType && !$root.nested?.squareup?.nested?.employeejobs?.nested?.Job && !$root.nested?.squareup?.nested?.employeejobs?.nested?.JobAssignment && !$root.nested?.squareup?.nested?.employeejobs?.nested?.WageData && !$root.nested?.squareup?.nested?.employeejobs?.nested?.JobUpdate) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE Wage @ squareup/employeejobs/data.proto at 13:1
 */
export const Wage = $root.lookupType('squareup.employeejobs.Wage');
fixType(Wage, {
  wageType: {
    required: true
  }
});
Builder.createAndAttachToType(Wage);
/**
 * SOURCE WageType @ squareup/employeejobs/data.proto at 14:3
 */
Wage.WageType = $root.lookupEnum('squareup.employeejobs.Wage.WageType').values;
/**
 * SOURCE Job @ squareup/employeejobs/data.proto at 35:1
 */
export const Job = $root.lookupType('squareup.employeejobs.Job');
fixType(Job, {
  merchantToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(Job);
/**
 * SOURCE JobAssignment @ squareup/employeejobs/data.proto at 55:1
 */
export const JobAssignment = $root.lookupType('squareup.employeejobs.JobAssignment');
fixType(JobAssignment, {
  merchantToken: {
    notEmpty: true
  },
  employeeToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(JobAssignment);
/**
 * SOURCE WageData @ squareup/employeejobs/data.proto at 78:1
 */
export const WageData = $root.lookupType('squareup.employeejobs.WageData');
fixType(WageData, {
  employeeToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(WageData);
/**
 * SOURCE JobUpdate @ squareup/employeejobs/data.proto at 101:1
 */
export const JobUpdate = $root.lookupType('squareup.employeejobs.JobUpdate');
fixType(JobUpdate, {
  id: {
    notEmpty: true
  },
  jobId: {
    notEmpty: true
  },
  newIsTipEligible: {
    required: true
  },
  newTitle: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(JobUpdate);